<template>
    <div class="setuser">
        <z-title title="多店铺设置" ref="title"></z-title>
        <el-card class="content1" ref="search">
            <div class="flex-n fac fjb ">

            <div class="flex-n fac">
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        maxlength="20"
                        placeholder="输入姓名"
                        title="输入姓名"
                        clearable
                        prefix-icon="el-icon-search"
                        v-model="userName">
                </el-input>
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        maxlength="32"
                        placeholder="输入账号名称"
                        title="输入账号名称"
                        clearable
                        prefix-icon="el-icon-search"
                        v-model="loginName">
                </el-input>
            </div>
            <div class="flex-n fac">
                <el-button type="primary" class="ele-btn2" @click="searchList">查询</el-button>
                <el-button type="primary" class="ele-btn1" @click="addUser">新增用户</el-button>
            </div>
            </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    element-loading-spinner="el-icon-loading"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        prop="userName"
                        fixed
                        label="姓 名"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="loginName"
                        label="账号名称"
                >
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="联系电话"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="roleName"
                        label="所属角色"
                        align="center">
                </el-table-column>
                <!--<el-table-column-->
                        <!--label="所属门店"-->
                        <!--align="center">-->
                    <!--<template slot-scope="scope">-->
                        <!--<template v-for="item,index in scope.row.store">-->
                            <!--{{item.storeName}}<template v-if="index< scope.row.store.length-1">、</template>-->
                        <!--</template>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="130"
                        align="center">
                    <template slot-scope="scope">
                        <div style="margin: 5px 0">
                            <el-button type="primary" class="ele-btn-small" @click="editUser(scope.row.id)">编辑
                            </el-button>
                            <el-popconfirm
                                    :title="'确定删除该用户吗？'"
                                    @confirm="delUser(scope.row.id)"
                                    class="ml-10"
                            >
                                <el-button slot="reference" type="primary" class="ele-btn-small">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--新增用户-->

        <el-dialog
                :close-on-click-modal="false"
                :visible.sync="showedit">
            <div slot="title">
                <z-title :title="editstate+'用户'"></z-title>
            </div>
            <el-form :model="dataForm" :rules="rules" ref="dataForm" class="rulefrom">
                <el-form-item label="姓 名" prop="userName" label-width="120px">
                    <el-input placeholder="请输入姓名" v-model="dataForm.userName" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="账号名称"  prop="loginName" label-width="120px">
                    <el-input placeholder="请输入登录账号名称" v-model="dataForm.loginName" maxlength="32"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone" label-width="120px">
                    <el-input placeholder="请输入联系电话" v-model="dataForm.phone" maxlength="11"
                              @input="dataForm.phone=$root.onlyNumber(dataForm.phone)"></el-input>
                </el-form-item>
                <el-form-item label="用户角色" prop="roleId" label-width="120px">
                    <el-select v-model="dataForm.roleId" @visible-change="getRoleList" placeholder="请选择角色"
                               style="width: 100%">
                        <el-option
                                v-for="item in roleList"
                                :key="item.id"
                                :label="item.roleName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="所属店铺" prop="storeIds" :show-message="false"  label-width="120px">-->
                    <!--<el-select v-model="dataForm.storeIds" @visible-change="showAllStoreList"-->
                               <!--placeholder="请选择需要绑定的店铺" style="width: 100%">-->
                        <!--<el-option-->
                                <!--v-for="item in allStoreList"-->
                                <!--:key="item.storeId"-->
                                <!--:label="item.storeName"-->
                                <!--:value="item.storeId">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('dataForm')">保 存</el-button>
                    <el-button @click="showedit = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            ZTitle},
        name: "user",
        data() {
            var validatetel = (rule, value, callback) => {
                if(value&&value.length!=11||!value){
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            return {
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height:250,
                dataForm: {},
                editstate: '新增',
                showedit: false,

                userName: '',
                loginName: '',
                id: '',

                // allStoreList: [],
                roleList: [],
                dataList: [],

                rules: {
                    userName: [
                        {max: 8, message: '最大允许输入8个字符', trigger: 'change'},
                        {required: true, message: '姓名不能为空', trigger: 'blur'}
                    ],
                    loginName: [
                        {max: 32, message: '最大允许输入32个字符', trigger: 'change'},
                        {required: true, message: '账号名称不能为空', trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, validator: validatetel, trigger: 'change'},
                    ],
                    roleId: [
                        {required: true, message: '用户角色不能为空', trigger: 'change'}
                    ],
                    storeIds: [
                        { required: true, trigger: 'change'}
                    ],

                },


            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            this.getDataList();
            // this.showAllStoreList(true);
            this.getRoleList(true);
        },
        watch: {
            showedit(newval, oldval) {
                if (!newval) {
                    this.$refs.dataForm.resetFields();
                }
            }
        },
        methods: {
            // //全部店铺
            // showAllStoreList(isshow) {
            //     if (isshow) {
            //         this.$axios.post('/store/dropDownBoxAll').then(res => {
            //             console.log(res)
            //             this.allStoreList = res.data.list;
            //         }).catch(err => {
            //             this.$message.error(err.msg);
            //         })
            //     }
            // },
            //角色列表
            getRoleList(isshow) {
                if (isshow)
                    this.$axios.get("/role/dropDownBoxByStoreId/"+this.$root.getStorage('storeId')).then(res => {
                        this.roleList = res.data.list;
                    }).catch(err => {
                        this.$message.error(err.msg);
                    })
            },
            //用户列表接口
            getDataList() {
                this.loading = true;
                this.$axios.post('/user/userList', {
                    "storeId": this.$root.getStorage('storeId'),
                    "currentPage": this.currentPage,
                    "pageSize": this.pageSize,
                    "userName": this.userName,
                    "loginName": this.loginName
                }).then(res => {
                    console.log(res)
                    this.dataList = res.data.list;
                    this.total = res.data.total;
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            //搜索
            searchList() {
                this.currentPage = 1;
                this.getDataList();
            },
            //新增
            addUser() {
                this.showedit = true;
                this.editstate = '新增';
            },
            //编辑
            editUser(id) {
                console.log('编辑',id)
                this.id=id;
                this.showedit = true;
                this.editstate = '编辑';
                this.$axios.get('/user/findById/'+id).then(res=>{
                    this.dataForm=res.data;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //删除
            delUser(id) {
                console.log('刪除',id)
                this.$axios.post('/user/logicDeleteByIds',id).then(res=>{
                    this.$message.success('删除用户成功！');
                    this.getDataList();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //添加提交
            addSubmit(){
                let {userName,loginName,phone,mark,roleId}=this.dataForm;

                this.$axios.post('/user/saveUser', {
                    "userName": userName,
                    "loginName": loginName,
                    "phone": phone,
                    "mark": mark,
                    "roleId": roleId,
                    "storeIds": this.$root.getStorage('storeId')
                }).then(res => {
                    this.currentPage = 1;
                    this.getDataList();
                    this.$message.success('新增用户成功！');
                    this.showedit = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit(){
                let {userName,loginName,phone,mark,roleId}=this.dataForm;
                this.$axios.post('/user/updateUser',{
                        "id": this.id,
                        "userName": userName,
                        "loginName": loginName,
                        "phone": phone,
                        "roleId": roleId,
                        "storeIds": this.$root.getStorage('storeId')
                }).then(res=>{
                    this.$message.success('编辑用户成功！')
                    this.getDataList();
                    this.showedit = false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.editstate == '新增') {
                            this.addSubmit();
                        } else {
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pageSize = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.currentPage = val;
                this.getDataList();
            },
        },
    }
</script>

<style scoped lang="scss">
    .setuser {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
    }
</style>